import { parse, format, parseISO, isValid } from 'date-fns';
import constants from '@/shared/constants';

export const currency = (value: string | number | undefined, numDecimals: number) =>
  typeof value === 'undefined'
    ? ''
    : new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: numDecimals,
      }).format(Number(value));

export const currencyTwoDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

export const currencyNoDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

export function titleCase(str: string) {
  if (typeof str !== 'string') {
    return '';
  }
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export const phoneNumber = (number: string | null) =>
  !number || number.length === 0 ? '' : number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

export const formatDateToDMY = (date: string | null) => {
  const formattedDate =
    typeof date === 'string'
      ? (() => {
          const parsed = parse(date, 'yyyy-MM-dd', new Date());
          return isValid(parsed) ? format(parsed, 'PPP') : '';
        })()
      : '';
  return formattedDate;
};

export const formatDate = (date: string, fmt = 'MM/dd/yyyy') => {
  let fd;
  try {
    fd = formatDateFns(date, fmt);
  } catch (_error) {
    // Fallback to a default format if parsing fails
    fd = format(new Date(date), fmt);
  }
  return fd;
};

export async function sha256(input: string) {
  return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(input)).then((h) => {
    const hexes = [];
    const view = new DataView(h);
    for (let i = 0; i < view.byteLength; i += 4) {
      hexes.push(`00000000${view.getUint32(i).toString(16)}`.slice(-8));
    }
    return hexes.join('');
  });
}

export const formatDateFns = (
  date: string | Date | null,
  desiredFormat: string = constants.DATE_SLASH
): string => {
  if (!date) {
    return '';
  }

  if (typeof date === 'string' && date.includes('/')) {
    return format(new Date(date), desiredFormat);
  }

  if (typeof date === 'string') {
    return format(parseISO(date), desiredFormat);
  }

  return format(date, desiredFormat);
};

export const toUTCDate = (date: string | null | Date) => {
  const d = new Date(date ?? '');
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
};
